import { StyleSheet } from 'react-native';
import type { DimensionValue } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const skeletonStyles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
});

export const getSkeletonContainerStyle = (
  theme: Theme,
  width: DimensionValue,
  height: number,
  borderRadius: number,
) =>
  ({
    width,
    height,
    borderRadius,
    backgroundColor: theme.gray[300],
    overflow: 'hidden' as const,
  }) as const;


